
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "logout",
      resolverType: "mutation",
      routePath: "/logout",
      httpMethod: "POST",
    });
  